"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MSG_SERVER_ERROR = exports.MSG_SEARCHING = exports.MSG_SEARCH_TEXT = exports.MSG_NO_RESULTS = void 0;
var MSG_NO_RESULTS = 'No Items Found';
exports.MSG_NO_RESULTS = MSG_NO_RESULTS;
var MSG_SEARCHING = 'searching...';
exports.MSG_SEARCHING = MSG_SEARCHING;
var MSG_SEARCH_TEXT = 'Search here...';
exports.MSG_SEARCH_TEXT = MSG_SEARCH_TEXT;
var MSG_SERVER_ERROR = 'Sorry, Something went wrong...!!!';
exports.MSG_SERVER_ERROR = MSG_SERVER_ERROR;